import script from "./BaseHeading.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseHeading.vue?vue&type=script&setup=true&lang=js"

import "./BaseHeading.vue?vue&type=style&index=0&id=f4d56912&scoped=true&lang=css"

import exportComponent from "/workspaces/e-commerce-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f4d56912"]])

export default __exports__